export const InternalServerError = () => {
  return (
    <div className="size-full flex flex-col gap-6 items-center justify-center">
      <span className="font-bold text-5xl text-purple-950">
        Internal server error
      </span>
      <span className="text-lg">
        A server error occured, our technical team is currently working on the
        problem and things should be working shortly
      </span>
    </div>
  );
};
